import React from 'react'
import {Flex, Text} from '../../utils/chakraMonomorphic'

import {ActionButton, CustomIcon} from '../../components'
import {useAuth} from '../../stores/AuthStore'
import {EmptyResultError} from '../../customErrors'
import copy from './copy.json'

export const AuthErrorView: React.FC<React.PropsWithChildren> = () => {
  const {error, logout} = useAuth()

  const isEmptyResultError = error instanceof EmptyResultError

  const authErrorMessage = isEmptyResultError
    ? copy.noCampAccess
    : copy.authFailure

  const navigateToLogin = async (): Promise<void> => {
    // logout() rejects on server-logout failure (already logged inside it).
    // This runs from an onClick handler React won't await, so swallow to
    // avoid an unhandled rejection.
    await logout('login').catch(() => {
      // already logged inside AuthStore.logout
    })
  }

  return (
    <Flex
      alignItems='center'
      justifyContent='center'
      height='100vh'
      width='100%'>
      <Flex alignItems='center' justifyContent='center' flexDir='column'>
        <CustomIcon
          name='phone'
          h={['90%', '100%']}
          w={['90%', '100%']}
          maxH={['60px']}
        />
        <Text fontSize='1.5rem' mt='40px' color='#1F2223' fontWeight='bold'>
          {authErrorMessage.title}
        </Text>
        <Text
          fontSize='1rem'
          mt='8px'
          color='#1F2223'
          width={isEmptyResultError ? '380px' : '435px'}
          textAlign='center'>
          {authErrorMessage.description}
        </Text>
        <ActionButton
          variant='solid'
          type='submit'
          mt='16px'
          onClick={navigateToLogin}>
          {authErrorMessage.button}
        </ActionButton>
      </Flex>
    </Flex>
  )
}
